var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"keyboard-key",class:[_vm.keyClass, _vm.stated ? 'stated' : '', _vm.uppercase ? 'uppercase' : ''],style:(`flex-grow: ${_vm.importance}`),on:{"mousedown":function($event){$event.preventDefault();return ((e) => e.stopPropagation()).apply(null, arguments)},"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.displayKey)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }